import styled from "styled-components";
import { Navbar } from "react-bootstrap";
import { LogoutCurve } from "iconsax-react";

export const StyledNavbar = styled(Navbar)`
  background: var(--white-color);
  height: 80px;
  box-shadow: 1px 6px 20px 2px rgba(62, 165, 219, 0.14);
  @media screen and (max-width: 758px) {
    height: 60px;
  }
`;

export const StyledLogoutCurve = styled(LogoutCurve)`
  transform: rotate(180deg);
`;
